module.exports = __webpack_public_path__ + "static/quiz_question_girl_boy_bg-c90a12092ab75adc4c4dacc9f3194fae.svg";